import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

export const userWallet = (userId) => Http.get(`/admin/users/${userId}/wallet`)
export const userTransactions = (userId, params = '') => Http.get(`/admin/users/${userId}/transactions${serialize(params)}`)
export const userSubscriptions = (userId, params = '') => Http.get(`/admin/users/${userId}/subscriptions${serialize(params)}`)
export const userProducts = (userId, params = '') => Http.get(`/admin/users/${userId}/products${serialize(params)}`)
export const userProductsSummary = (userId) => Http.get(`/admin/users/${userId}/products-summary`)
export const userCreditHistory = (userId, params = '') => Http.get(`/admin/users/${userId}/credit-history${serialize(params)}`)
export const userFinancialSummary = (userId) => Http.get(`/admin/users/${userId}/financial-summary`)

export const userNotificationTemplates = (userId) => Http.get(`/admin/users/${userId}/notification-templates`)
export const syncUserNotificationTemplates = (userId, templateIds) =>
	Http.put(`/admin/users/${userId}/notification-templates`, { template_ids: templateIds })
